import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HolidayCalendarComponent } from './holiday-calendar/holiday-calendar.component';
import { LeaveAprvlRejectionComponent } from './leave-aprvl-rejection/leave-aprvl-rejection.component';
import { CompOffMngmntComponent } from './comp-off-mngmnt/comp-off-mngmnt.component';
import { EmplyLeaveBalanceComponent } from './emply-leave-balance/emply-leave-balance.component';
import { UserLeaveAtndceComponent } from './user-leave-atndce/user-leave-atndce.component';
import { EmployeeLeaveReportComponent } from './employee-leave-report/employee-leave-report.component';

const routes: Routes = [
  {path:'hldyclndr' ,component:HolidayCalendarComponent},
  {path:'leaveaprvlrjctn' ,component:LeaveAprvlRejectionComponent},
  {path:'compoffmngmnt' ,component:CompOffMngmntComponent},
  {path:'emplyleavebal' ,component:EmplyLeaveBalanceComponent},
  {path:'userleaveatndce' ,component:UserLeaveAtndceComponent},
  {path:'empLeaveRpt' ,component:EmployeeLeaveReportComponent},

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeaveManagementRoutingModule {

  
 }
